import Image from 'next/image'
import clsx from 'clsx'

/* styling */
import styles from './_.module.css'

interface Props {
  title?: string
  list: {
    id: string | number
    tag?: string | null
    color?: string | null
    title: string
    description: string
    image?: StrapiImageFile
    bgColor: string | null
  }[]
}

function ContentTypeFeatures({ title, list }: Props): JSX.Element {
  return (
    <section>
      {title ? (
        <div className="container | font-heading | py-10 md:py-18">
          <h2
            className="text-3xl md:text-5xl font-semibold tracking-tight text-blue-90 | max-w-col-9 mb-4"
            dangerouslySetInnerHTML={{ __html: title }}
          />
        </div>
      ) : null}
      <div className="md:container">
        {list.map(item => (
          <div
            key={item.id}
            className="grid grid-cols-1 md:grid-cols-12 gap-8 items-center | md:rounded-2xl py-10 md:py-12 md:px-18 md:mb-14"
            style={{ background: item.bgColor ?? '' }}
          >
            <div className="md:col-span-5 px-5 md:px-0">
              {item.tag ? (
                <div className="flex items-center mb-6">
                  <span
                    className="w-8 h-8 rounded-md"
                    style={{ background: item.color ?? '' }}
                  />
                  <p className="text-sm text-gray-90 tracking-widest uppercase font-semibold ml-4">
                    {item.tag}
                  </p>
                </div>
              ) : null}

              <h3
                className="font-heading text-3xl lg:text-4xl font-semibold text-gray-90 | mb-10"
                dangerouslySetInnerHTML={{ __html: item.title }}
              />
              <div
                className={clsx(
                  styles.description,
                  'font-body text-lg lg:text-xl text-blue-web-90'
                )}
                dangerouslySetInnerHTML={{ __html: item.description }}
              />
            </div>

            <div className="md:col-start-7 md:col-end-13 | md:justify-self-stretch md:rounded-2xl">
              {item.image ? (
                <Image
                  src={item.image.url}
                  alt={item.image.alternativeText ?? ''}
                  width={item.image.width}
                  height={item.image.height}
                  className="px-8 md:px-4 mx-auto"
                />
              ) : null}
            </div>
          </div>
        ))}
      </div>
    </section>
  )
}

export default ContentTypeFeatures
